/*
    node_js
    3/15/2021 9:15 AM
    by Oleksandr
*/

import React, {useState} from "react";
import Window from "./Window";
import HistFlightsList from "./lists/HistFlightsList";
import ActiveFlightsList from "./lists/ActiveFlightsList";

const ActiveWindow = (props) => {
    const {flights, pttWindows, setPttWindows, calcFlightsNum, startDate, isEpp, isPlt, tickValue} = props;
    const columns = ['c','type', 'adep', 'ades', 'entryCop', 'entryTime', 'exitCop', 'exitTime', 'rfl'];
    const columnsText = ['Callsign','TYPE', 'ADEP', 'ADES', 'ENTRY', 'TIME', 'EXIT', 'TIME', 'RFL'];
    const [actSort, setActSort] = useState('rfl');
    const sort = (arr) => arr.sort((a, b) => (a[actSort] > b[actSort]) ? 1 : ((b[actSort] > a[actSort]) ? -1 : 0));

    return (
        <>
            <Window isVisible={true} toggleWindow={() => {
                setPttWindows({...pttWindows, activeWindow: false});
                setPttWindows({...pttWindows, plannerWindow: false});
            }}
                    label={isEpp?'Active Flights ('+flights.length+')':isPlt?'Planner ('+flights.length+')':''} width={isEpp?620:'auto'}
                    content={
                        <>
                            <div style={{overflowY: "scroll", height: isEpp?"500px":"auto"}}>
                                <table>
                                    <thead>
                                    <tr>{columns.map((heading, index) => <th className='filterHistFlights headerTh'
                                                                             onClick={() => setActSort(heading)}>{columnsText[index]}</th>)}
                                        {isEpp && <th className='headerTh'></th>}
                                    </tr>
                                    </thead>

                                    <ActiveFlightsList flights={sort(flights)}
                                                     columns={columns} calcFlightsNum={calcFlightsNum}
                                                       startDate={startDate}
                                                       isEpp={isEpp} isPlt={isPlt}
                                                       tickValue={tickValue}/>
                                </table>
                            </div>
                        </>}
            />
        </>
    )
}

export default ActiveWindow;